import { isEmpty } from '../../../utility/validation';
import { FIELD_TYPES } from '../../../constants/fieldTypes';

export const prepareTrackLevels = (currentLevelId, track = []) => {
  const currentLevelIndex = track?.levels?.findIndex(
    trLvl => trLvl.id === currentLevelId
  );
  const totalLevelsToShow = 2;
  const numberOfLevels = track?.levels?.length;
  let start = 0;
  let visibleLevels;

  if (isEmpty(currentLevelIndex) && isEmpty(numberOfLevels)) {
    if (currentLevelIndex === numberOfLevels - 1) {
      start = numberOfLevels - totalLevelsToShow;
      visibleLevels = track.levels.slice(start >= 0 ? start : 0);
    } else if (currentLevelIndex === 0) {
      visibleLevels = track.levels.slice(start, totalLevelsToShow);
    } else {
      visibleLevels = track.levels.slice(
        currentLevelIndex,
        currentLevelIndex + 2
      );
    }

    return visibleLevels.map(level => {
      const isCurrentLevel = level.id === currentLevelId;

      return {
        ...level,
        isCurrentLevel,
      };
    });
  }

  return [];
};

export const prepareCareerInfoFields = (shouldAddJobTitle, shouldAddLevel) => {
  const { SELECT } = FIELD_TYPES;

  return [
    ...(shouldAddJobTitle
      ? [
          {
            name: 'jobTitle',
            type: SELECT,
            required: true,
            optionsKey: 'jobTitles',
            parser: {
              value: 'id',
              label: 'name',
            },
            validators: [
              {
                validator: isEmpty,
                type: 'required',
              },
            ],
          },
        ]
      : []),
    ...(shouldAddLevel
      ? [
          {
            name: 'framework',
            required: true,
            type: SELECT,
            optionsKey: 'frameworks',
            dependants: [{ name: 'track', value: null }],
            parser: {
              value: 'id',
              label: 'name',
            },
            validators: [
              {
                validator: isEmpty,
                type: 'required',
              },
            ],
          },
          {
            name: 'track',
            required: true,
            type: SELECT,
            optionsKey: 'tracks',
            dependants: [{ name: 'level', value: null }],
            parent: {
              name: 'framework',
              options: 'frameworks',
            },
            parser: {
              value: 'id',
              label: 'name',
            },
            validators: [
              {
                validator: isEmpty,
                type: 'required',
              },
            ],
          },
          {
            name: 'level',
            type: SELECT,
            optionsKey: 'levels',
            required: true,
            shouldRemoveFieldSpacing: true,
            shouldRemoveFieldError: true,
            parent: {
              name: 'track',
              options: 'tracks',
            },
            parser: {
              value: 'id',
              label: 'name',
            },
            validators: [
              {
                validator: isEmpty,
                type: 'required',
              },
            ],
          },
        ]
      : []),
  ];
};
